module.exports = __webpack_public_path__ + "img/greendot.4af26a24.svg";